module.exports = __webpack_public_path__ + "static/media/bd.e99cb11f.svg";